// Hockey Age Groups with Gender
export const HOCKEY_AGE_GROUPS = [
  // Boys/Men's divisions
  { value: 'boys_mite_8u', label: 'Boys Mite (8U)', hasTiers: false }, // Developmental
  { value: 'boys_squirt_10u', label: 'Boys Squirt (10U)', hasTiers: true, tierType: 'squirt' },
  { value: 'boys_peewee_12u', label: 'Boys Peewee (12U)', hasTiers: true, tierType: 'peewee' },
  { value: 'boys_bantam_14u', label: 'Boys Bantam (14U)', hasTiers: true, tierType: 'bantam' },
  { value: 'boys_junior_gold', label: 'Boys Junior Gold (HS)', hasTiers: true, tierType: 'junior_gold' },
  
  // Girls divisions
  { value: 'girls_8u', label: 'Girls 8U', hasTiers: true, tierType: 'girls' },
  { value: 'girls_10u', label: 'Girls 10U', hasTiers: true, tierType: 'girls' },
  { value: 'girls_12u', label: 'Girls 12U', hasTiers: true, tierType: 'girls' },
  { value: 'girls_15u', label: 'Girls 15U', hasTiers: true, tierType: 'girls' },
]

// Team Tiers by Type
export const TEAM_TIERS = {
  squirt: [
    { value: 'A', label: 'A' },
    { value: 'B1', label: 'B1' },
    { value: 'B2', label: 'B2' },
    { value: 'C', label: 'C' },
  ],
  peewee: [
    { value: 'AA', label: 'AA' },
    { value: 'A', label: 'A' },
    { value: 'B1', label: 'B1' },
    { value: 'B2', label: 'B2' },
    { value: 'C', label: 'C' },
  ],
  bantam: [
    { value: 'AA', label: 'AA' },
    { value: 'A', label: 'A' },
    { value: 'B1', label: 'B1' },
    { value: 'B2', label: 'B2' },
    { value: 'C', label: 'C' },
  ],
  junior_gold: [
    { value: 'A', label: 'A' },
    { value: 'B', label: 'B' },
    { value: 'C', label: 'C' },
  ],
  girls: [
    { value: 'A', label: 'A' },
    { value: 'B', label: 'B' },
  ],
}

// Referee types
export const REFEREE_TYPES = [
  { value: 'none', label: 'None (Practice format)' },
  { value: 'coach_led', label: 'Coach-Led' },
  { value: 'paid_refs', label: 'Paid Referees' },
]

// Distance presets for search
export const DISTANCE_PRESETS = [
  { value: '', label: 'Any distance' },
  { value: '15', label: 'Within 15 miles' },
  { value: '30', label: 'Within 30 miles' },
  { value: '45', label: 'Within 45 miles' },
  { value: '60', label: 'Within 60 miles' },
  { value: '90', label: 'Within 90 miles' },
]

// Helper to get available tiers for an age group
export function getAvailableTiers(ageGroupValue) {
  const ageGroup = HOCKEY_AGE_GROUPS.find(ag => ag.value === ageGroupValue)
  if (!ageGroup || !ageGroup.hasTiers) return []
  return TEAM_TIERS[ageGroup.tierType] || []
}

// Marketing features for rotation
export const MARKETING_FEATURES = [
  { title: 'AI-Powered Dispatches', desc: 'Turn scattered notes into polished team emails in seconds' },
  { title: 'Auto Calendar Sync', desc: 'Import from SportsEngine, TeamSnap, or Google Calendar automatically' },
  { title: 'Team Wiki & Quick Links', desc: 'Hotel info, tournament links, saved for instant parent access' },
  { title: 'Public Team Portal', desc: 'Searchable email archive - no login required for parents' },
  { title: 'File Sharing & Roster', desc: 'Permission slips, practice plans, roster all in one place' },
  { title: 'Privacy-First Design', desc: 'Roster shows "First L." only - full control over what\'s public' },
  { title: 'Snack Schedule Manager', desc: 'Automated snack assignments with email reminders' },
  { title: 'Email Compliance Built-In', desc: 'CAN-SPAM compliant with easy unsubscribe for every email' },
]

// Get random marketing feature
export function getRandomMarketingFeature() {
  return MARKETING_FEATURES[Math.floor(Math.random() * MARKETING_FEATURES.length)]
}

// Helper to get human-readable label for age group value
export function getAgeGroupLabel(value) {
  if (!value) return null
  const ageGroup = HOCKEY_AGE_GROUPS.find(ag => ag.value === value)
  return ageGroup ? ageGroup.label : value
}

// Helper to format team level display (age group + tier)
export function formatTeamLevel(ageGroupValue, tierValue) {
  const ageLabel = getAgeGroupLabel(ageGroupValue)
  if (!ageLabel) return tierValue || 'Unknown'
  if (!tierValue) return ageLabel
  return `${ageLabel} ${tierValue}`
}

